import React from "react";
// Route Specific
import { Routes, Route } from "react-router-dom";
import ScrollTopBehaviour from "../components/ScrollTopBehaviour";
import ProductLanding from "../views/all-home-pages/ProductLanding";
import ProductLandingDark from "../views/all-home-pages/ProductLandingDark";
// All HOME PAGE ROUTES

import ClientCtrl from "../views/all-home-pages/ClientCtrl";
import TermsAndCondition from "../views/inner-pages/service/TermsAndCondition";

// Contact us inner pages
import ContactClientCtrl from "../views/inner-pages/pages/contact/ContactClientCtrl";


// About us inner pages

import Communication from "../views/inner-pages/features/Communication";
import AboutDocumentation from "../views/inner-pages/pages/about/AboutDocumentation";

// Pricing inner pages
import PricingClientCtrl from "../views/inner-pages/pages/pricing/PricingClientCtrl";


// FEATURES DROPDOWN ALL ROUTES
import Login from "../views/inner-pages/features/miscellaneous/Login";
import SignUp from "../views/inner-pages/features/miscellaneous/SignUp";
import ClientManagement from "../views/inner-pages/features/ClientManagement";
import LeadsManagement from "../views/inner-pages/features/LeadsManagement";
import Overview from "../views/inner-pages/features/Overview";
import OrdersManagement from "../views/inner-pages/features/OrdersManagement";

// BLOGS DROPDOWN ALL ROUTES
import BlogOne from "../views/inner-pages/blog-pages/BlogOne";
import BlogV4 from "../views/inner-pages/blog-pages/BlogV4";
import BlogTwo from "../views/inner-pages/blog-pages/BlogTwo";

// Not Found Page
import NotFound from "../views/NotFound";


// Demo

import ClientDemo from "../components/demo/ClientDemo";
import PricingYearly from "../views/inner-pages/pages/pricing/PricingYearly";
import Test from "../components/pricing/pricing-one/Test";
import Blogadd from "../components/blog/Blogadd";
import Blogshow from "../components/blog/Blogshow";
import Blogedit from "../components/blog/Blogedit";
import BlogView from "../components/blog/BlogView";
import BlogDisplay from "../views/inner-pages/blog-pages/BlogDisplay";
import CKEditorComponent from "../components/blog/Testck";
import BlogCategoryShow from "../components/blog/BlogCategoryShow";
import Categoryedit from "../components/blog/Categoryedit";
import Categoryadd from "../components/blog/Categoryadd";


const AllRoutes = () => {
  return (
    <>
      <ScrollTopBehaviour />
      <Routes>
        {/* products Dropdown Routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/SignUp" element={<SignUp />} />
        <Route path="/terms-condition" element={<TermsAndCondition />} />
        
        {/* NotFound Route */}
        <Route path="*" element={<NotFound />} />

        <Route path="/demo" element={<ClientDemo />} />

        {/* Home */}
        <Route path="/" element={<ClientCtrl />} />

        {/* Products */}
        <Route
          path="/clientctrl-features"
          element={<Overview />}
        />
        <Route path="/features-client-management" element={<ClientManagement />} />
        <Route path="/features-leads-management" element={<LeadsManagement />} />
        <Route
          path="/features-orders-management"
          element={<OrdersManagement />}
        />
        <Route path="/features-communication" element={<Communication />} />

        {/* About Us */}
        <Route path="/about" element={<AboutDocumentation />} />

        {/* Contact */}
        <Route path="/contact" element={<ContactClientCtrl />} />
        
        {/* Pricing */}
        <Route path="/pricing" element={<PricingClientCtrl />} />
        <Route path="/pricingYearly" element={<PricingYearly/>} />
        <Route path="/test" element={<Test/>} />

        {/* Blog */}
        <Route path="/blog" element={<BlogV4 />} />
        <Route path="/testck" element={<CKEditorComponent />} />
        <Route path="/software" element={<BlogOne />} />
        <Route path="/blog-how-to-improve-sales" element={<BlogTwo />} />
        <Route path="/blog/:slug" element={<BlogDisplay />} />
        <Route path="/blog-management/blogadd" element={<Blogadd />} />
        <Route path="/category-management/category-add" element={<Categoryadd />} />
        <Route path="/blog-management/index" element={<Blogshow />} />
        <Route path="/category-management/index" element={<BlogCategoryShow />} />
        <Route path="/blog-management/blogedit/:id" element={<Blogedit />} />
        <Route path="/category-management/categoryedit/:id" element={<Categoryedit />} />
        <Route path="/blog-management/blogview/:id" element={<BlogView />} />
        <Route path="/product-landing" element={<ProductLanding />} />
      </Routes>
    </>
  );
};

export default AllRoutes;
